<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <PostForm :basePost="post" :basepostName="name" :loading="loading" @submit-requested="submitRequested"></PostForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import PostForm from './PostForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                post: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { PostForm },
        computed:
        {
            ...mapState('posts', ['getPostByIdOutput']),
        },
        methods: {
            ...mapActions('posts', ['getPostById']),
            ...mapActions('posts', ['putPost']),
            submitRequested(post) {
                this.putPost(post);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "PostsList"});
            }
            else {
                this.getPostById(this.$route.query.id);
            }
        },
        watch:
        {
            getPostByIdOutput: function (output) {
                if (!output && !output.data) {
                    router.push({name: "PostsList"});
                }
                else {
                    this.post = output.data;
                    this.loading = false;
                }
            }
        }
    }
</script>